export default "__VITE_ASSET__D$QaFKRA__"